// extracted by mini-css-extract-plugin
var _1 = "AiForm_bottomControls__cd69e";
var _2 = "AiForm_buttonsRight__c93fa";
var _3 = "AiForm_commandsList__9d054";
var _4 = "AiForm_controls__ccee9";
var _5 = "AiForm_iconWrapper__04a11";
var _6 = "AiForm_input__83b4c";
var _7 = "AiForm_loader__bb8ba";
var _8 = "AiForm_prompt__3145e";
var _9 = "AiForm_promtTextCard__017e0";
var _a = "AiForm_responseContainer__04fc1";
var _b = "AiForm_result__cd3de";
var _c = "AiForm_resultText__d1a05";
var _d = "AiForm_resultTitle__d72bc";
var _e = "AiForm_root__815bd";
var _f = "AiForm_title__575f3";
export { _1 as "bottomControls", _2 as "buttonsRight", _3 as "commandsList", _4 as "controls", _5 as "iconWrapper", _6 as "input", _7 as "loader", _8 as "prompt", _9 as "promtTextCard", _a as "responseContainer", _b as "result", _c as "resultText", _d as "resultTitle", _e as "root", _f as "title" }
